import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';

// Services
import { ApiRestService } from '../services/shared/api-rest.service';

@Injectable({
  providedIn: 'root'
})
export class SpreadsheetsService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
  ) { }

  // Consulta de todos las ordenes de compra cerradas
  public getSpreadsheets() {

    this.http.get(this._apiRestService.APIURL.serv204).subscribe(
      (data) => {
        console.log(data)
        if (data['estado'] === "ok") {
          console.log("is ok")
        } else {
          console.log("not ok")
        }
      },
      (error) => {
        console.error('Error:', error);
      }
    );
    return 0;
  }
}
